module.exports = __webpack_public_path__ + "img/safflower.5e401dd8.svg";